import React from 'react';

export const BillingUsage: React.FC = () => {
  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <h1 className="text-3xl font-bold">Billing & Usage</h1>
    </div>
  );
};
